export const KEYS = {
  SEND_PASSWORD_EMAIL: 'send-password-email',
  VERIFY_OTP: 'verify-otp',
  RESEND_OTP: 'resend-otp',
  RESET_PASSWORD: 'reset-password',
  REGISTER: 'register',
  LOGIN: 'login',
  REQUEST_LOGIN_OTP: 'request-login-otp',
  VERIFY_LOGIN_OTP: 'verify-login-otp',
  VERIFY_LINK_OTP: 'verify-link-otp',
  VERIFY_LINK_PASSWORD: 'verify-link-password',
  FORGOT_PASSWORD: 'forgot-password',
  LOGOUT: 'logout',
  GET_CHAT: 'get-chat',
  USER: 'user-details',
  PENDING_FRIEND_REQUESTS: 'pending-friend-requests',
  FRIEND_SUGGESTIONS: 'friend-suggestions',
  ARCHIVE: 'archive',
  SEND_FRIEND_REQUEST: 'send-friend-request',
  NOTIFICATIONS: 'notifications',
  DELETE_NOTIFICATION: 'delete-notification',
  NOTIFICATION_UNREAD_COUNT: 'notification-unread-count',
  MARK_ALL_NOTIFICATIONS_READ: 'mark-all-notifications-read',
  MARK_MESSAGES_AS_READ: 'mark-messages-as-read',
  RESPOND_FRIEND_REQUEST: 'respond-friend-request',
  ACCEPTED_FRIENDS: 'accepted-friend-request',
  BLOCKED_USERS: 'blocked-users',
  UNBLOCK: 'unblock-users',
  FAVORITES: 'favorites',
  GROUPS: 'groups',
  USER_GROUPS: 'user-groups',
  CREATE_GROUP: 'create-group',
  CREATE_BROADCAST: 'create-broadcast',
  MY_BROADCASTS: 'my-broadcasts',
  MESSAGES: 'messages',
  GET_MESSAGES: 'get-messages',
  SEND_MESSAGE: 'send-message',
  RECENT_CHATS: 'recent-chats',
  USER_UPDATE: 'user-details-update',
  SELECTED_USER_KEY: 'meetzy_selected_user_id',
  STATUS_FEED: 'status-feed',
  CREATE_STATUS: 'create-status',
  VIEW_STATUS: 'view-status',
  DELETE_STATUS: 'delete-status',
  REPLY_STATUS: 'reply-status',
  DOCUMENTS: 'documents',
  SEARCH_DOCUMENTS: 'searchDocuments',
  TOGGLE_BLOCK: 'toggle-block',
  STICKERS: 'stickers',
  CHAT_WALLPAPERS: 'chat-wallpapers',
  EDIT_MESSAGE: 'edit-message',
  DELETE_MESSAGE: 'delete-message',
  GROUP_INFO: 'group-info',
  GROUP_MEMBERS: 'group-members',
  UPDATE_GROUP: 'update-group',
  ADD_GROUP_MEMBERS: 'add-group-members',
  REMOVE_GROUP_MEMBERS: 'remove-group-members',
  UPDATE_MEMBER_ROLE: 'update-member-role',
  LEAVE_GROUP: 'leave-group',
  UPDATE_GROUP_SETTINGS: 'update-group-settings',
  TOGGLE_PIN_CONVERSATION: 'toggle-pin-conversation',
  ARCHIVE_CONVERSATION: 'archive-conversation',
  UNARCHIVE_CONVERSATION: 'unarchive-conversation',
  SEARCH_MESSAGES: 'search-messages',
  SEARCH_BLOCK: 'search-block',
  SEARCH_FRIEND: 'search-friend',
  UNBLOCK_USER: 'unblock-user',
  ARCHIVE_USER: 'archive-user',
  SEARCH_ARCHIVE: 'search-archive',
  UNARCHIVE_USER: 'archive-user',
  SEARCH_FAVORITE: 'search-favorit',
  ADD_REACTION: 'message-reaction',
  SEARCH_CONTACT: 'search-contact',
  SEARCH_GROUP: 'search-group',
  SEARCH_RECENT: 'search-Recent',
  ALL_FAQS: 'all-faqs',
  ALL_PAGES: 'all-pages',
  SETTINGS: 'settings',
  PUBLIC_SETTINGS: 'public-settings',
  PROFILE_INFO: 'profile-info',
  CHAT_EXPORT: 'chat-export',
  ALL_REPORT_SETTINGS: 'all-report-settings',
  CREATE_REPORT: 'create-report',
  CALL_HISTORY: 'call-history',
  ALL_USER_SETTINGS: 'all-user-settings',
  UPDATE_USER_SETTING: 'update-user-setting',
  DELETE_ACCOUNT: 'delete-account',
  CONNECT_TO_DRIVE: 'connect-to-drive',
  ARCHIVE_ALL_CHATS: 'archive-all-chats',
  CLEAR_ALL_CHAT: 'clear-all-chats',
  DELETE_ALL_CHATS: 'delete-all-chats',
  DELETE_CHATS: 'delete-chats',
  CONTACT_INQUIRIES: 'contact-inquiries',
  FRIEND_LIST: 'friend-list',
  LOGIN_INIT: 'login-init',
  DEMO_STATUS: 'demo-status',
  VERIFY_REGISTRATION_OTP: 'verify-registration-otp',
  LINK_IDENTIFIER: 'link-identifier',
  LINK_PASSWORD: 'link-password',
  MUTE_STATUS: 'mute-status',
  MUTED_STATUSES: 'muted-statuses',
  E2E_PUBLIC_KEY: 'e2e-public-key',
  E2E_SAVE_KEY: 'e2e-save-key',
  E2E_DELETE_KEY: 'e2e-delete-key',
  DISAPPEARING_MESSAGES: 'disappearing-messages',
  FORGET_CHAT_LOCK_PIN: 'forget-chat-lock-pin',
  VERIFY_CHAT_LOCK_PIN_OTP: 'verify-chat-lock-pin-otp',
  RESET_CHAT_LOCK_PIN: 'reset-chat-lock-pin',
  ALL_PLANS: 'all-plans',
  ACTIVE_PLANS: 'active-plans',
  PLAN_DETAILS: 'plan-details',
  MY_SUBSCRIPTION: 'my-subscription',
  USER_LIMITS: 'user-limits',
  SUBSCRIPTION_DETAILS: 'subscription-details',
  INITIATE_VERIFICATION: 'initiate-verification',
  CONFIRM_PAYMENT: 'confirm-payment',
  SYNC_STRIPE_SUBSCRIPTION: 'sync-stripe-subscription',
  GET_MY_VERIFICATION_STATUS: 'get-my-verification-status',
  UPLOAD_DOCUMENTS: 'upload-documents',
  IMPERSONATION_STATUS: 'impersonation_status',
  STOP_IMPERSONATION: 'stop_impersonation',
  GET_TRANSLATION: 'get-translation',
  UPLOAD_CHAT_FILES: 'upload-chat-files',
}
